<template>
  <b-modal id="bv-modal-remove-checkin" size="sm" hide-header centered @ok="removeCheckin" @show="showModal"
           @hidden="resetModal">
    <div class="text-center">
      <Icon name="grTrash" width="36" class="mb-3"/>
      <h1 class="modal-title mb-2">{{ $t('modal_remove_checkin.title') }}</h1>
      <template v-if="canRemove">
        <h4 class="modal-subtitle mb-4">{{ $t('modal_remove_checkin.subtitle') }}</h4>
        <h4 class="h5 code">{{ picacode }}</h4>
      </template>
      <template v-else>
        <h4 class="modal-subtitle">{{ $t('modal_remove_checkin.attention_title') }}</h4>
        <h4 class="modal-subtitle mb-3">{{ $t('modal_remove_checkin.attention_text') }}</h4>
      </template>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 mb-2  ml-sm-2 mb-sm-0" v-if="canRemove">
            <b-button variant="danger" block @click="ok()">
              {{ $t('modal_remove_checkin.action_confirm') }}
            </b-button>
          </div>
          <div class="flex-grow-1  order-sm-0 mr-sm-2">
            <b-button variant="light" block @click="cancel()">
              {{ $t('modal_remove_checkin.action_cancel') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
import EventService from "@/services/Event.js"
import {mapGetters} from "vuex";

export default {
  props: {
    picacode: {
      type: String,
      required: true
    },
    checkinId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      canRemove: true,
      digitalItemId: null
    }
  },
  computed: {
    ...mapGetters('appConfig', [
      'hideCart'
    ]),
    ...mapGetters('cartDigitalItems', [
      'getDigitalItemByPicaCode'
    ])
  },

  methods: {
    showModal() {
      if (!this.hideCart) {
        // verifico se nel carrello c'è un digitalItem relativo a questo picacode
        const digitalItem = this.getDigitalItemByPicaCode(this.picacode)
        if (digitalItem && digitalItem.media_ids && digitalItem.media_ids.length > 0) {
          this.digitalItemId = digitalItem.id
        }
      }

    },

    resetModal() {
      this.digitalItemId = null
      this.canRemove = true
    },

    removeCheckin() {
      EventService.removeCheckin(this.checkinId).then(() => {
        this.$bvToast.toast(this.$tc('notifications.checkin_removed', this.picacode))
        this.$emit('checkin-removed', this.checkinId)
        this.$router.push({name: 'checkins-list'}).catch(err => {
          // Ignore the vuex err regarding navigating to the page they are already on
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }).catch(error => {
        if (error.response.status === 400) {
          this.$bvToast.toast(
              error.response.data.detail,
              {variant: 'danger', autoHideDelay: 5000})
        }
      })
    }
  }
}
</script>

